import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = props => {
  const getDark = () => {
    const col = JSON.parse(localStorage.getItem("dark"));
    return col;
  };
  const [dark, setDark] = useState(getDark());

  useEffect(() => {
    localStorage.setItem("dark", JSON.stringify(dark));
  }, [dark]);

  return (
    <ThemeContext.Provider value={[dark, setDark]}>
      {props.children}
    </ThemeContext.Provider>
  );
};
